<template>
  <div class="page-404">
    <div class="page-404-content">
      <img class="img" src="../../assets/img/404.png" />
    </div>
    <div class="back-wrap">
      <span>访问的页面不存在~~~，</span>
      <span class="back" @click="back">返回首页>></span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.page-404 {
  height: 100%;
  width: 100%;
  background-color: #f1f5f9;
  overflow: hidden;
  .page-404-content {
    text-align: center;
    color: #fff;
    .img {
      vertical-align: middle;
      height: 400px;
    }
  }
  .back-wrap {
    text-align: center;
    margin-top: 50px;
    font-size: 14px;
    .back {
      color: @themeColor;
      cursor: pointer;
    }
  }
}
</style>
